var BaseService = (function () {
    function BaseService(httpClient) {
        Object.defineProperty(this, "httpClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.httpClient = httpClient;
    }
    Object.defineProperty(BaseService.prototype, "get", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (url, config) {
            return this.httpClient.get(url, config);
        }
    });
    Object.defineProperty(BaseService.prototype, "post", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (url, data, config) {
            return this.httpClient.post(url, data, config);
        }
    });
    Object.defineProperty(BaseService.prototype, "put", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (url, data, config) {
            return this.httpClient.put(url, data, config);
        }
    });
    Object.defineProperty(BaseService.prototype, "delete", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (url, config) {
            return this.httpClient.delete(url, config);
        }
    });
    return BaseService;
}());
export default BaseService;
